import { render, staticRenderFns } from "./LpProducts.vue?vue&type=template&id=d470326e"
import script from "./LpProducts.vue?vue&type=script&lang=js"
export * from "./LpProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports